import OriginType from '../enums/OriginType';

export default function originType(input: string): string | null {

    switch(input) {

        case OriginType.MZI: return 'MZI';
        case OriginType.SOIL: return 'Bodem';
        default: return null;
    }
}
